import getPathName from '../getPathName';

export default (location = {}) => `/${getPathName(location)}`;
